
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComMessageGoogle as ObiComMessageGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-com-message-google.js';
 
 
 

 
 export const ObiComMessageGoogle = createComponent({
   react: React,
   tagName: 'obi-com-message-google',
   elementClass: ObiComMessageGoogleElement,
   events: {
     
   }
  });
 
 